import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import {
  userTypedRepairReasons,
  selectedRepairReasonObject,
  eligibilityResponseObject,
} from "../../ducks/redux/actions/dashboardReducer.actions";
import {
  userChosenPropertyId,
  userChosenHighLevelDescription,
  userChosenSOR,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  isEditState,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenDuplicateQuestion,
  userChosenEmergencyQuestion,
  repairPriorityValue,
  showFooter,
  DMCChecksavedAnswer,
} from "../../ducks/redux/actions/userChoices";
import { PremisesType } from "../../models/Customer";
import * as api from "../../api";
import { useTranslation } from "react-i18next";
import {
  EligibilityErrorCode,
  MaintenanceResponsibility
} from "../../models/Property";
import Loader from "react-loader-spinner";
import { RouteComponentProps } from "react-router-dom";
import {
  getHeatingHotWaterCase,
  getMaintResp,
  getRepairResp,
} from "../../ducks/redux/actions/getAddress";
import Message from "../../storybook/Message";
import { isNullOrUndefined } from "../../utils/formatting";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { RepairPriorityCode } from "../../models/Repair/RepairPriority";
import moment from "moment";
import { isContinueButtonDisabled, RemoveAllDMCData, storeSORDAMP } from "../../ducks/redux/actions/FinancialReferral";
import { RepairPriority } from "../../models/Repair/CreateRepair";
import { resetHazardAssessmentData, saveHazardGetQuestionsData, savePreAssessmentQuestionsData } from "../../ducks/redux/actions/hazardAssessment";
import { Helper } from "../../utils/Helper/HelperUtil";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";

export interface RepairReasonProps extends RouteComponentProps<any> {
  suggestions: string[];
  setButtonDisabled: (a: boolean) => void;
  locatioAlert: string[];
  getMandatoryData: (args: any) => void;
  resetAlerts: (a: Array<any>) => void;
}
const RepairReason: React.FC<RepairReasonProps> = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  //fetch typed object
  const fetchedRepairReasonsSelection = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.fetchedRepairReasonsSelect
  );

  const userChosenHighLevelDescriptionBackButton = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenHighLevelDescription
  );

  let suggestionList;
  const [displayRepairEligibilityAlert, setDisplayRepairEligibilityAlert] = useState("none");
  const [errorCode, setErrorCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [userInput, setUserInput] = useState();
  const [inputValue, setInputValue] = useState(userChosenHighLevelDescriptionBackButton ?? "");
  const [isOrbisBlockMsg, setIsOrbisBlockMsg] = useState(false);
  const [blockEMERepair, setBlockEMERepair] = useState(false);
  const [isSelectedValue, setSelectedValue] = useState(false);
  const [repairReasonEvent, setRepairReasonEvent] = useState(null);
  let parentAssetType: any = null;
  let assetSubType: any = null;
  let currentRepairAsset: any = null;
  const EditState = useSelector(
    (state: any) => state.userChoicesReducer?.isEditState
  );
  const customerDetails = useSelector(
    (state: any) => state.addresses?.saveCustomerDetails
  );
  const [fetchedRepairReasonsData, setFetchedRepairReasonsData] = useState(props.suggestions);
  //Check Repair Eligibility
  let premisesType = "";
  let maintsResp = "FMFULL";
  let repairResp = "";
  let additionalRepairInfo = false; //!!asset?.description //??
  let isRepairEligible = true;
  let isCustomerView = false; // to do discuss
  let uprn = ""; // asset store - filter
  let sorCode: string | null = "";
  let defectValue = false; //got
  let heatingRepairContext: string | null = "";

  const addressesData = useSelector(
    (state: any) => state?.addresses?.customerassociatedassets
  );
  const checkEnhancedEligibility = useSelector(
    (state: any) => state.userChoicesReducer?.checkEnhancedRepairEligibilityMyPeabody
  );
  const selectedproperty = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.tracks?.[0]?.assetType
  );

  const selectedPropertyId = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.tracks?.[0]?.assetId
  );

  const selTenancyGroup = useSelector(
    (state: any) => state?.userChoicesReducer?.selectedTenancyGroup
  );

  //selector for fetching supplimentaryCodes
  const supplimentaryCodes = useSelector(
    (state: any) => state.userChoicesReducer?.supplimentaryCodes
  );
  const assetId = useSelector(
    (state: any) => state?.addresses?.assetId
  );
  const isHHSRSRepairEnabledToggleValue = useSelector(
    (state: any) => state?.userChoicesReducer?.checkHHRSRepairEnabledToggleValue
  );

  const fetchAppConfigHotjarToggleValue = async () => {
    try {
      const SORConfig = await api.GetAppConfigToggleValue("dmcsorcodes");
      dispatch(storeSORDAMP(SORConfig?.value))
    } catch (error) {
      console.log("Error fetching SOR Config: ", error);
    }
  }

  useEffect(() => {
    dispatch(isContinueButtonDisabled(blockEMERepair ?? false));
  }, [blockEMERepair])


  useEffect(() => {
    if (props.history.action === "POP" || userChosenHighLevelDescriptionBackButton) {
      setInputValue(userChosenHighLevelDescriptionBackButton);
      setSelectedValue(true)
      repairReasonChangeAction("pageInit", userChosenHighLevelDescriptionBackButton);
    }
    fetchAppConfigHotjarToggleValue()
  }, []);

  useEffect(() => {
    props.getMandatoryData(inputValue);
  }, [inputValue]);

  useEffect(() => {
    suggestionClickHandler(repairReasonEvent, userInput);
  }, [isSelectedValue, repairReasonEvent, userInput]);

  const loadHazardQuestionsForRepairReason = async (
    selectedReason: any
  ) => {
    dispatch(savePreAssessmentQuestionsData([]));
    dispatch(saveHazardGetQuestionsData([]));
    const repairReason = selectedReason;
    const isPreAssessmentRequired = repairReason?.isPreAssessmentRequired === true;
    const isHazardRepairReason = repairReason?.isHazard === true;

    if (!isPreAssessmentRequired && !isHazardRepairReason) {
      return;
    }

    const assetType = selectedproperty?.toUpperCase();
    const hazardType = repairReason?.hazardType;
    const diagnosticId = repairReason?.diagnosticId;
    const preAssessmentCategory = isPreAssessmentRequired &&
      diagnosticId !== undefined &&
      diagnosticId !== null
      ? `${Helper.PreAssessmentCategoryPrefix}-${diagnosticId}`
      : "";

    if (!assetType || !hazardType || (isPreAssessmentRequired && !preAssessmentCategory)) {
      return;
    }

    try {
      const response = isPreAssessmentRequired
        ? await api.getHHSRSHazardQuestions(
          assetType,
          hazardType,
          true,
          preAssessmentCategory
        )
        : await api.getHHSRSHazardQuestions(assetType, hazardType);
      const allQuestions = response?.[0]?.questions || [];

      if (isPreAssessmentRequired) {
        dispatch(savePreAssessmentQuestionsData(allQuestions));
        dispatch(saveHazardGetQuestionsData(
          allQuestions.filter((question: any) =>
            !Helper.isPreAssessmentCategory(question.category)
          )
        ));
      } else {
        dispatch(saveHazardGetQuestionsData(allQuestions));
      }
    } catch (e) {
      console.error(e);
      dispatch(saveHazardGetQuestionsData([]));
      if (isPreAssessmentRequired) {
        dispatch(savePreAssessmentQuestionsData([]));
      }
      throw e;
    }
  };

  const getParentAssetType = async (assetId: string) => {
    if (!Array.isArray(addressesData)) return null;
    // Flatten addressesData if it's an array of arrays
    const flatAddresses = Array.isArray(addressesData[0])
      ? addressesData.flat()
      : addressesData;
    const idx = flatAddresses.findIndex((item: any) => item.id === assetId);
    if (idx === -1) return null;
    // Find the next asset that is not a "Divided Block"
    for (let i = idx + 1; i < flatAddresses.length; i++) {
      if (flatAddresses[i].assetType !== "Divided Block") {
        return flatAddresses[i].assetType;
      }
    }
    return null;
  }

  const sorDetermination = async (): Promise<any> => {

    let maintenanceResponsibilities: MaintenanceResponsibility[] = [];
    // get maintenanceResponsibilities for all assets
    const addressHierarchy = addressesData.flat();
    const addressHierarchyDetailPromises = addressHierarchy.map((item: any) => {
      return api.getAssetsByid(item.id);
    });

    const addressHierarchyDetail = await Promise.all(addressHierarchyDetailPromises);

    addressHierarchyDetail.forEach((item: any) => {
      const responsibilities = heatingAttributeFromResponsibilities(
        item.maintenanceResponsibilities
      );
      const rep = {
        type: item.assetType,
        value: responsibilities,
      };
      maintenanceResponsibilities.push(rep);
    });

    if (maintenanceResponsibilities?.length > 0) {
      const propertyAttribute =
        maintenanceResponsibilities.find((item) => {
          return item.type === PremisesType.Property
            ? item.value
            : "";
        })?.value ?? "";
      const dividedBlockAttribute =
        maintenanceResponsibilities.find((item) => {
          return item.type === PremisesType.DividedBlock
            ? item.value
            : "";
        })?.value ?? "";
      const blockAttribute =
        maintenanceResponsibilities.find((item) => {
          return item.type === PremisesType.Block ? item.value : "";
        })?.value ?? "";
      const estateAttribute =
        maintenanceResponsibilities.find((item) => {
          return item.type === PremisesType.EstateArea;
        })?.value ?? "";

      // call sor determination api
      const sorDeterminationResponse = await api.getSorDetermination({
        propertyAttribute,
        dividedBlockAttribute,
        blockAttribute,
        estateAttribute,
        context: currentRepairAsset.assetType as PremisesType,
      });

      if (isNullOrUndefined(sorDeterminationResponse)) {
        return;
      }
      if (sorDeterminationResponse?.errorCode) {
        setDisplayRepairEligibilityAlert("block");
        setIsLoading(false);
        
        if (sorDeterminationResponse.errorCode === "E32") {
          setErrorCode("SSR047");
          setDisplayRepairEligibilityAlert("block");
          props.setButtonDisabled(false);
          dispatch(getHeatingHotWaterCase(sorDeterminationResponse.errorCode));
          return "NA";
        } 

        setErrorCode("SSR049");
        props.setButtonDisabled(true);
        return null;
      }

      sorCode = sorDeterminationResponse.sor;
      setDisplayRepairEligibilityAlert("none");
      return sorCode;
    }

  }

  const prepareRepairPriorityPayload = (selectedReason: any) => {

    const raisedFormattedDate = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss");

    dispatch(selectedRepairReasonObject([selectedReason]));

    if (selectedReason?.sors.length > 0 && selectedReason?.sors[0].sorCode) {
      selectedReason.sors[0].sorCode = modifySorCode(selectedReason, supplimentaryCodes)
    }

    // Fetch workProgramme from the first matched reason's first SOR
    const workProgramme = selectedReason?.sors?.[0]?.workProgramme;

    // Adding isANATypes for customer preferences
    let isAnaTypeValue = false;
    if (customerDetails?.preferences?.length > 0) {
      isAnaTypeValue = customerDetails?.preferences?.some((additionalNeedAlert: any) => additionalNeedAlert.preference.type === 'additionalNeeds');
    }

    let tenureCode = "";
    if (customerDetails?.tenanciesSummaries.length > 1) {
      const tenancySummary = customerDetails?.tenanciesSummaries?.filter(
        (tenancy: any) =>
          tenancy?.tenancySummary?.tenancyEndDate === null
      );
      tenureCode = tenancySummary[0]?.tenancySummary?.tenancyTenureCode;
    }
    else {
      tenureCode = customerDetails?.tenanciesSummaries[0]?.tenancySummary?.tenancyTenureCode;
    }

    return {
      isEmergency: selectedReason?.priority === "Emergency",
      repairType: selectedReason?.sors?.[0]?.sorCode,
      isVulnerable: false,
      isRecall: false,
      isEMA: "N",
      channel: RepairChannel.CustomerSelfService,
      raisedDate: raisedFormattedDate,
      description: selectedReason?.description,
      tenureCode: tenureCode,
      workProgramme: workProgramme,
      premisesType: selectedproperty,
      isAnaType: isAnaTypeValue,
      isV14Upgradable: selectedReason?.isV14Upgradable,
      hasSeasonalPriority: selectedReason?.hasSeasonalPriority || false
    };
  }

  const evaluateEnhancedRepairEligibility = async (selectedReason: any, sorCode: any, repairPriority: any) => {
    try {
      // call Enhanced Repair Eligibility api
      const selectedPriorityCode = selectedReason?.priority === RepairPriority.Emergency
        ? RepairPriorityCode.Emergency : RepairPriorityCode.NextAvailable;

      const advancedPayload = {
        priority: repairPriority ?? selectedPriorityCode,
        sor: sorCode || undefined,
        channel: "CustomerSelfService",
      };
      const response =
        await api.postEnhancedRepairEligibility(
          advancedPayload
        );
      if (
        response?.isEligible === false &&
        response?.errorCode === "E35"
      ) {
        setIsOrbisBlockMsg(true);
        setErrorCode("");
      }
      if (
        response?.isEligible === false &&
        response?.errorCode === "E36"
      ) {
        setBlockEMERepair(true);
        setErrorCode("");
      }

      return response.isEligible
    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      props.history.push("/repairJourneyErrorPage");
    }
  }
  const checkRepairEligibility = async (selectedReason: any, repairPriority: any, isHeatingTriage: boolean = false) => {
    assetSubType = currentRepairAsset.assetSubType;
    dispatch(eligibilityResponseObject(currentRepairAsset));
    premisesType = currentRepairAsset?.assetType;


    additionalRepairInfo = false
    if (selectedReason?.additionalData?.length > 0) {
      additionalRepairInfo = selectedReason?.additionalData[0]?.description != "";
    }

    //start logic to get isEligibleRepair
    isRepairEligible = selectedReason?.additionalData?.some(
      (item: any) =>
        item.isEligible &&
        item.assetType === selectedproperty &&
        item.tenancyTypes?.some(
          (tt: any) =>
            tt.toLowerCase() ===
            selTenancyGroup.toLowerCase()
        )
    ) ?? false;
    // end
    isCustomerView = true; // as discussed true for customer search
    uprn = currentRepairAsset.uprn;
    //added check for SupplementaryCode 
    sorCode = selectedReason?.sors[0]?.sorCode;

    props.setButtonDisabled(false);
    //call api and set errorMessage 
    const eligibilityResponse = await api.getRepairEligibility(
      premisesType,
      maintsResp,
      repairResp,
      additionalRepairInfo,
      isRepairEligible,
      isCustomerView,
      sorCode,
      uprn,
      defectValue,
      heatingRepairContext,
      assetSubType,
      parentAssetType
    );

    dispatch(userChosenEligibilityErrorCode(eligibilityResponse));
    if (eligibilityResponse?.length > 0) {
      const isEligible = eligibilityResponse[0].isEligible;
      const error = eligibilityResponse[0].errorCode ?? "";
      const maintainHeatingTriageMessage = isUndefinedNullOrEmpty(error) && isHeatingTriage

      if(!maintainHeatingTriageMessage) {
        //If there is Repair eligibility error code, only then replace HHW Triage message
        setErrorCode(error);
        setDisplayRepairEligibilityAlert(isUndefinedNullOrEmpty(error) ? "none" : "block");
      }

      props.setButtonDisabled(!isEligible);
    }

  };

  const inputTextChangeHandler = async (event: any, newValue: any) => {
    setSelectedValue(true);
    setRepairReasonEvent(event);
    // removing all hazard save data
    dispatch(resetHazardAssessmentData());
    dispatch(saveHazardGetQuestionsData([]));
    dispatch(savePreAssessmentQuestionsData([]));
    if (EditState === true) {
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      dispatch(userChosenVulnerabilityQuestion("No"));
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      dispatch(userChosenEmergencyQuestion(""));
      dispatch(isEditState(false));
      dispatch(userChosenVandalismAdditionalInformation(""));
      dispatch(userChosenVandalismQuestion("No"));
      dispatch(userChosenAdditionalDescription(""));
      dispatch(userChosenDuplicateQuestion(""));
      dispatch(RemoveAllDMCData(null));
      dispatch(DMCChecksavedAnswer(""))
    }
    setSelectedValue(true)
    setUserInput(newValue);
    dispatch(userChosenHighLevelDescription(newValue));
    setIsLoading(true);
    setIsOrbisBlockMsg(false);
    setBlockEMERepair(false);
    dispatch(userChosenSOR(""));
    setErrorCode("");
    setDisplayRepairEligibilityAlert("none");
    setInputValue(newValue);
    props.setButtonDisabled(true);
    await setRepairDetailsFromRepairReasonSelection(newValue);
  };

  const suggestionClickHandler = (event: any, newInputValue: any, reason?: string) => {
    repairReasonChangeAction(event?.type, newInputValue, reason);
  };

  const repairReasonChangeAction = (eventType: any, newInputValue: any, reason?: string) => {
    if (EditState === true) {
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      dispatch(userChosenVulnerabilityQuestion("No"));
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      dispatch(userChosenEmergencyQuestion(""));
      dispatch(isEditState(false));
      dispatch(userChosenVandalismAdditionalInformation(""));
      dispatch(userChosenVandalismQuestion("No"));
      dispatch(userChosenDuplicateQuestion(""));
    }

    // NOTE 
    // Keyboard type: suggestionClickHandler, which is fine
    // User Select from Drop down: suggestionClickHandler => inputTextChangeHandler => suggestionClickHandler

    // ie. Continue will be enabled for appropriate messageing when page is initialized
    if (eventType == "change" && reason === "input" && newInputValue !== inputValue) {
      props.setButtonDisabled(true);
      props.resetAlerts([]);
      setSelectedValue(false)
      setInputValue(newInputValue);

      dispatch(userTypedRepairReasons(newInputValue));
      setFetchedRepairReasonsData(props.suggestions);

      if (newInputValue == "") {
        //enable continue button to allow for validation messages
        props.setButtonDisabled(false);
      }
    } else if (isUndefinedNullOrEmpty(inputValue) || reason === "reset") {
      //enable continue button to allow for 
      // page init ie. isUndefinedNullOrEmpty(inputValue) OR
      // back action (reason === "reset") on the page and repair reason was already selected
      props.setButtonDisabled(false);
    }
  }


  const setRepairDetailsFromRepairReasonSelection = async (value: string) => {
    try {

      const assetIdentifier = selectedPropertyId ?? assetId
      if (isNullOrUndefined(currentRepairAsset)) {
        const assetDetails = await api.getAssetsByid(assetIdentifier);
        parentAssetType = await getParentAssetType(assetDetails.id)
        dispatch(userChosenPropertyId(assetDetails.id));
        currentRepairAsset = assetDetails;
      }

      const selectedReason = fetchedRepairReasonsSelection?.find(
        (reason: any) => reason.description === value
      );

      if (isNullOrUndefined(selectedReason)) {
        return;
      }

      let repairPriorityReq = prepareRepairPriorityPayload(selectedReason);
      const repairPriority = (await api.postRepairPriority(repairPriorityReq))?.repairPriority;
      dispatch(repairPriorityValue(repairPriority));

      let isEnhancedRepairEligibilityPassed = checkEnhancedEligibility ? await evaluateEnhancedRepairEligibility(selectedReason, sorCode, repairPriority) : true;

      if (!isEnhancedRepairEligibilityPassed) {
        return;
      }

      dispatch(userChosenSTATUS("Unappointed,Appointed,In Progress"));
     
      let determinedSORCode;
      if (selectedReason?.isSORDeterminationRequired === true) {
        determinedSORCode = await sorDetermination();
        if (isNullOrUndefined(determinedSORCode)) {
          return;
        }

        sorCode = determinedSORCode;
      } else {
        sorCode = selectedReason.sors.find((x: any) => x.sorCode)?.sorCode;
      }

      maintsResp =
        currentRepairAsset?.maintenanceResponsibilities?.find(
          (resp: any) => resp.type === "MAINTSRESP"
        )?.value ?? "";
      repairResp =
        currentRepairAsset?.maintenanceResponsibilities?.find(
          (resp: any) => resp.type === selectedReason?.element
        )?.value ?? "";
      const isRepairResponsibilityEMA = (maintsResp === "EMAFULL" || repairResp === "EMAFULL");
      defectValue = currentRepairAsset?.statuses?.isInDefects ?? false;

      dispatch(getMaintResp(maintsResp));
      dispatch(getRepairResp(repairResp));
      dispatch(userChosenSOR(sorCode));
      await checkRepairEligibility(selectedReason, repairPriority, sorCode === "NA");

      if (selectedReason?.isHazard === true &&
        isHHSRSRepairEnabledToggleValue &&
        !isRepairResponsibilityEMA && !defectValue) {
        await loadHazardQuestionsForRepairReason(selectedReason);
      }
      setIsLoading(false);

    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
    }
  };

  if (props.locatioAlert?.length > 0) {
    let suggestionSubList = props.locatioAlert.map((message, index) =>
    (<Message className="error-msg" data-testid={"locatioAlert_" + index} key={message}>
      {message}
    </Message>))

    suggestionList = (
      <div data-testid="alert-warning" role="alert" placeholder="alert-message">
        {suggestionSubList}
      </div>
    );
  } else if (isOrbisBlockMsg) {
    props.setButtonDisabled(true);
    suggestionList = (
      <Message className="warning-msg" data-testid="OrbisBlock_warning">
        {t("OrbisBlockMsg1")}<br />
        {t('OrbisBlockMsg2')} <strong>{t('OrbisBlockNumber')}</strong> {t('OrbisBlockMsg3')}
      </Message>
    );
  } else if (blockEMERepair) {
    props.setButtonDisabled(true);
    suggestionList = (
      <Message className="warning-msg" data-testid="blockEMERepair_warning">
        {t("BlockEMERepairMsg")}<br />
      </Message>
    );
  } else if (!fetchedRepairReasonsData?.length && inputValue?.length > 1 && !isSelectedValue) {
    props.setButtonDisabled(true);
    suggestionList = (
      <Message className="error-msg">
        {t("Repair_Reason_NoMatch_Message")}
      </Message>
    );
  } else if (
    (errorCode == EligibilityErrorCode.SSR037 || errorCode == EligibilityErrorCode.E21)
  ) {
    let errorCodeArray: string[] = [];
    errorCodeArray = t(errorCode).split("?");
    let errorCodeValue = errorCodeArray[0];
    errorCodeArray = errorCodeArray.slice(1);
    let items = errorCodeArray.map((item, index) => {
      if (EligibilityErrorCode.SSR037 && [3, 4, 5].includes(index)) {
        return <strong key={item}> <li >{item}</li> </strong>
      }
      if (EligibilityErrorCode.SSR037 && [2].includes(index)) {
        return <li key={item}> {item.split(":")[0]}:<strong>{item.split(":")[1]}</strong> </li>
      }
      return <li key={item}>{item}</li>;
    }
    );
    suggestionList = (
      <div
        data-testid="alert-warning"
        style={{ display: displayRepairEligibilityAlert }}
        className="warning mb-8"
        role="alert"
        placeholder="alert-message"
      >
        <div className="w-full px-2 py-2 bg-red-20 flex items-center">
          <div className="px-4 pr-8">
            <i className="fas fa-exclamation-circle me-2 text-brick-100 w-6 h-6 bolder-font"></i>
          </div>
          <div className="flex items-center text-black">
            <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
              {errorCodeValue}
              {errorCode == EligibilityErrorCode.SSR037 ? (
                <ol>{items}</ol>
              ) : (
                <ul>{items}</ul>
              )}
            </p>

          </div>
        </div>
      </div>
    );
  } else if (errorCode == EligibilityErrorCode.E23) {
    suggestionList = (
      <div
        data-testid="alert-warning"
        style={{ display: displayRepairEligibilityAlert }}
        className="alert alert-warning error-reason global-txt"
        role="alert" placeholder="alert-message"
      >
        <span className="global-error-icon covid-error">
          <i className="fas fa-exclamation me-2"></i>
        </span>
        <span className="remove-margin-left">{t(errorCode)}</span>
      </div>
    );
  } else if (errorCode && inputValue) {
    suggestionList = (
      <Message className="error-msg" data-testid="alert-warning">
        {t(errorCode)}
      </Message>
    );
  }
  else if (isLoading) {
    suggestionList = (
      <Loader
        type="ThreeDots"
        color="#00BFFF"
        height={50}
        width={50}
        timeout={5000}
      />
    );
  }


  return (
    <div className="pt-24">
      <h6>{t("Repair_Reason_Main_Header_Text")}</h6>
      <p className="td">{t("Repair_Reason_Sub-heading_Text")}</p>
      {fetchedRepairReasonsData && (
        <Autocomplete
          className="mtb"
          data-testid="high-level-repair"
          onChange={inputTextChangeHandler}
          inputValue={inputValue}
          onInputChange={suggestionClickHandler}
          id="high-level-repair"
          freeSolo
          disableClearable
          filterOptions={() => props.suggestions}
          options={props.suggestions}
          size="small"
          renderInput={params => (
            <div ref={params.InputProps.ref}>
              <label htmlFor="html" className="labelform">a</label>
              <input {...params.inputProps}
                id="html"
                name="html"
                placeholder={t("repair_reason_placeholder")}
                className="txtBox-Input m-0"
                data-hj-allow=""
              />
            </div>
          )}
        />
      )}
      {suggestionList}
      <p className="pb-20 td">{t("Repair_Reason_Example")}</p>
    </div>
  );
};

export const modifySorCode = (
  selectedReason: any,
  supplimentaryCodes: string[]
): string => {
  const isTotalLossOfWaterWithSupplementaryCodes =
    selectedReason?.description === "Total loss of water" &&
    supplimentaryCodes?.includes("FISPUMPS02");

  return isTotalLossOfWaterWithSupplementaryCodes
    ? "COMPUMP"
    : selectedReason?.sors?.[0]?.sorCode;
};


export const heatingAttributeFromResponsibilities = (
  responsibilities: MaintenanceResponsibility[]
) => {
  if (!responsibilities) return "";

  const elementsToCheck = new Set([
    "HEAT",
    "HEATGAS",
    "HEATOIL",
    "HEATELEC",
  ]);
  return responsibilities
    .filter((resp) => elementsToCheck.has(resp.type))
    .map((resp) => resp.value)
    .filter((value) => {
      const valueLowerCase = value?.toLowerCase();
      return (
        !!value &&
        valueLowerCase !== "null" &&
        valueLowerCase !== "unknown" &&
        valueLowerCase !== "none"
      );
    })
    .join("+");
};

export default RepairReason;
